import apiRequest from "./apiRequest";

export const sh10RegisterApi = {

    fetchSh10Register: (accountId, token) => {
    return apiRequest(`/api/register/sh10?accountId=${accountId}`, 'GET', token);
  },
  

  // Submit MGT-1 form data
  submitSh10Form: (formData, accountId, token) => {
    return apiRequest(`/api/register/sh10?accountId=${accountId}`, 'POST', token, formData);
  },

  addNewEntry: (id, payload, token) => {
    return apiRequest(
      `/api/register/sh10/add-entry/${id}`,
      "POST",
      token,
      payload          // ← body is forwarded as-is to apiRequest
    );
  },

  
};